/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/json_extract.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Extracts a value from a JSON string using a subset of\nJSONPath syntax.',
  examples: [
    'ROW log = """{"severity":"ERROR","body":"Payment processing failed"}"""\n| EVAL severity = JSON_EXTRACT(log, "severity")',
    'ROW log = """{"severity":"ERROR","body":"Payment processing failed"}"""\n| EVAL severity = JSON_EXTRACT(log, "$.severity")',
    'ROW log = """{"resource":{"service":{"name":"order-service"}}}"""\n| EVAL svc = JSON_EXTRACT(log, "resource.service.name")',
    'FROM json_logs\n| EVAL svc = JSON_EXTRACT(payload, "resource[\'service.name\']")\n| KEEP @timestamp, source, svc\n| SORT @timestamp\n| LIMIT 3',
    'ROW log = """{"spans":[{"name":"auth","duration":12},{"name":"db-query","duration":45}]}"""\n| EVAL span = JSON_EXTRACT(log, "spans[1].name")',
    'ROW log = """{"resource":{"service.name":"api-gateway","host.name":"api-server-03"},"severity":"INFO"}"""\n| EVAL resource = JSON_EXTRACT(log, "resource")',
    'ROW json = """["a","b","c"]"""\n| EVAL val = JSON_EXTRACT(json, "$[1]")\n| KEEP val',
    'ROW log = """{"trace":{"spans":[{"name":"auth","events":[{"type":"start"},{"type":"end"}]},{"name":"db","events":[{"type":"query"}]}]}}"""\n| EVAL event = JSON_EXTRACT(log, "trace.spans[0].events[1].type")\n| KEEP event',
  ],
  params: {
    string: 'A string containing valid JSON, or the `_source` field. If `null`, the function returns `null`.',
    path: 'A path expression identifying the value to extract, using a subset of JSONPath syntax. Supports dot notation (`user.name`), bracket notation for array indices (`items[0]`), and quoted brackets for keys with special characters (`[\'user.name\']`). The `$` prefix is optional. If `null`, the function returns `null`.',
  },
};

export default docs;
